var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import { H3 } from "@irati/ui/src/Headings";
import Close from "@irati/ui/src/Close";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
import tenantSetupTracking, { ResetModalClickedValues } from "@irati-tracking/tenant-setup";
import { ContentWrapper, CloseWrapper, WaitImageAbsolute, CustomModal } from "./styled";
var LoseChangesModal = /** @class */ (function (_super) {
    __extends(LoseChangesModal, _super);
    function LoseChangesModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (clicked) {
            var _a = _this.props, onHide = _a.onHide, handleReset = _a.handleReset;
            var params = { clicked: clicked };
            tenantSetupTracking.resetChangesModalAction(params);
            if (clicked === ResetModalClickedValues.Ok) {
                handleReset();
            }
            else {
                onHide();
            }
        };
        return _this;
    }
    LoseChangesModal.prototype.componentDidMount = function () {
        tenantSetupTracking.viewResetChangesModal();
    };
    LoseChangesModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, show = _a.show, load = _a.load;
        return (React.createElement(CustomModal, { dialogClassName: "custom-dialog", onHide: function () { return _this.onClick(ResetModalClickedValues.Blur); }, show: show },
            React.createElement(CloseWrapper, null,
                React.createElement(WaitImageAbsolute, { sizeInPx: 100 }),
                React.createElement(Close, { onClick: function () { return _this.onClick(ResetModalClickedValues.Cross); }, top: "20px", right: "20px" })),
            React.createElement(ContentWrapper, null,
                React.createElement(H3, { small: true },
                    React.createElement(FormattedMessage, { id: "setup_tenant.loseChangeModal.title" })),
                React.createElement(Para, { center: true },
                    React.createElement(FormattedMessage, { id: "setup_tenant.loseChangeModal.body" })),
                React.createElement("br", null),
                React.createElement(Para, { center: true },
                    React.createElement(FormattedMessage, { id: "setup_tenant.loseChangeModal.body2" }))),
            React.createElement(Flex, { justifyContent: "center", margin: 2, alignItems: "center" },
                React.createElement(Button, { tertiary: true, onClick: function () { return _this.onClick(ResetModalClickedValues.Cancel); }, marginRight: 2 },
                    React.createElement(FormattedMessage, { id: "setup_tenant.loseChangeModal.button.back" })),
                React.createElement(Button, { load: load, primary: true, onClick: function () { return _this.onClick(ResetModalClickedValues.Ok); } },
                    React.createElement(FormattedMessage, { id: "setup_tenant.loseChangeModal.button.proceed" })))));
    };
    return LoseChangesModal;
}(PureComponent));
export default LoseChangesModal;
